import { Component, /*OnInit, Renderer2*/ } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import localeIT from '@angular/common/locales/it';
// import { UtilityService } from './core/services/utility.service';
// import { HttpHeaders } from '@angular/common/http';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styles: []
})
export class AppComponent /*implements OnInit*/ {
	title = 'uploadDoc';

	constructor(translate: TranslateService/*,
		private utilityService: UtilityService,
		private renderer: Renderer2*/
	) {
		// currencyPipe
		registerLocaleData(localeIT);
		// this language will be used as a fallback when a translation isn't found in the current language
		translate.setDefaultLang('it');
		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translate.use('it');
	}

	/* ngOnInit() {
		// TODO uncomment
		// this.utilityService.hostListenerReload = this.renderer.listen('window', 'beforeunload', (event) => {
		//   event.returnValue = true;
		// });
	}*/
}
